<header class="modal-header">
    <div class="modal-title text-center text-white h3 w-100 p-5">
        <img src="../../../../../assets/icons/interrogation-icon.png" class="d-inline-block img-responsive mr-3"
            alt="" />
        Atención
    </div>
</header>
<section class="modal-body px-3 pb-3 py-5 border-bottom">
    <div class="text-center" [innerHTML]="mensaje"></div>
</section>
<section class="modal-body px-3 py-3 border-bottom">
    <div class="">{{descripcionCorrespondenciaSubCategoria}}</div>
</section>
<div class="modal-body">
    <p>Actividades económicas registradas actualmente en el RUT (DIAN) y/o en el Registro Mercantil (RUES)</p>
    <div class="table-responsive">
        <app-tablas [headers]="headers" [paginar]="false">
            <tr *ngFor="let item of actividadesEconomicas">
                <td>{{ item.actividad_economica_id }}</td>
                <td>{{ item.desc_actividad_economica }}</td>
                <td>
                    {{ item.origen_actividad_economica }}
                </td>
            </tr>
        </app-tablas>
    </div>
</div>
<footer class="modal-footer text-right">
    <button class="btn btn-primary" (click)="confirm()">Aceptar</button>
</footer>